const { POSITION_TYPE_CATEGORY_NAME, POSITION_TYPE_INTERNAL, POSITION_TYPE_ALL, POSITION_TYPE_INTERNAL_VALUE, POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE } = require("../../../components/pages/careers/careers-constants");
const getPublishCategoryValue = (position)=>{
    var _position_categories;
    const publishCategory = position === null || position === void 0 ? void 0 : (_position_categories = position.categories) === null || _position_categories === void 0 ? void 0 : _position_categories.find((category)=>category.name === POSITION_TYPE_CATEGORY_NAME);
    return publishCategory && publishCategory.value;
};
// filters positions by internal and external
const isPositionRelevantToType = (position, positionsType)=>{
    const publishCategoryValue = getPublishCategoryValue(position);
    return publishedPositionFitsType(publishCategoryValue, positionsType);
};
const publishedPositionFitsType = (publishCategoryValue, requestedPositionsType)=>{
    // If requesting all positions, show everything (both internal and external)
    if (requestedPositionsType === POSITION_TYPE_ALL) {
        return true;
    }
    if (requestedPositionsType === POSITION_TYPE_INTERNAL && publishCategoryValue) {
        return publishCategoryValue === POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE || publishCategoryValue === POSITION_TYPE_INTERNAL_VALUE;
    }
    // else - external. filter out only internal
    return !publishCategoryValue || publishCategoryValue !== POSITION_TYPE_INTERNAL_VALUE;
};
module.exports = {
    getPublishCategoryValue,
    isPositionRelevantToType,
    publishedPositionFitsType
};
